// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/NotificationBar/NotificationBar.css
// module id = 364
// module chunks = 0 1